<mat-sidenav-container class="fit-screen">
    <mat-sidenav-content>
        @if (requestProgressPercent) {
        <div class="progress-bar">
            <mat-progress-bar mode="determinate" [value]="requestProgressPercent"></mat-progress-bar>
        </div>
        } @else if (appService.loading()) {
        <div class="progress-bar">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        }
        @if (phitoSessionService.loggedIn() && hasNotificationPermission) {
        <phito-notification-center></phito-notification-center>
        }
        @if (showFullScreen()) {
        <div (mouseenter)="showFullScreenCancelButton.set(true)" (mouseleave)="showFullScreenCancelButton.set(false)"
            class="exit-full-screen">
            @if (showFullScreenCancelButton()) {
            <button (click)="exitFullScreen()" color="accent" mat-fab>
                <mat-icon style="transform: scale(2)">close</mat-icon>
            </button>
            }
        </div>
        }
        <!--
        @if (showScreenBlockLoader) {
            <div
                #screenBlockLoader
                [style.height]="screenBlockLoaderHeight"
                [style.width]="screenBlockLoaderWidth"
                style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    background-color: rgba(0, 0, 0, 0.2);
                    z-index: 9999;
                    top: 0;
                    left: 0;
                "
            >
                <div style="width: 200px">
                    <mat-progress-spinner
                        [diameter]="100"
                        [mode]="'indeterminate'"
                        color="accent"
                    ></mat-progress-spinner>
                </div>
                <div style="margin-top: 24px; display: flex; align-items: center; justify-content: center">
                    <div style="color: white; font-weight: bold">{{ screenBlockLoaderText }}</div>
                    <div class="spinner-loading-dots" style="width: 100px"></div>
                </div>
            </div>
        }-->

        <div class="site-wrapper">
            <!-- Ueberschriften Zeile -->
            @if (showToolbar()) {
            <div class="one-row toolbar">
                @if (appService.isDesktop()) {
                <phito-app-logo [fileSuffix]="logoFileSuffix" [logo]="logo" [logoHexId]="logoHexId()"
                    style="margin-left: 12px; margin-top: 12px"></phito-app-logo>
                }
                <div class="one-row" style="margin-left: 18px">
                    @if (!appService.isDesktop()) {
                    <button (click)="toggleSidenav()" mat-icon-button>
                        <mat-icon>menu</mat-icon>
                    </button>
                    }
                    @if (!appService.isDesktop()) {
                    <div>
                        <phito-app-logo [fileSuffix]="logoFileSuffix" [logo]="logo"
                            style="margin-left: 48px"></phito-app-logo>
                    </div>
                    }
                    @if (!appService.isMobile()) {
                    @if (options?.appName) {
                    <span style="margin-left: 24px; font-weight: bold">{{ options?.appName }}</span>
                    }
                    }
                    <span class="spacer"></span>
                    @if (!appService.isMobile()) {
                    <ng-content></ng-content>
                    }
                    <span class="spacer"></span>
                    @if (options?.hasPhitomHierachy && showPhitomTree()) {
                    <div #phitomtree style="position: relative">
                        <div #overlayTrigger="cdkOverlayOrigin" cdkOverlayOrigin class="one-row"
                            style="cursor: pointer">
                            @if (!appService.isMobile()) {
                            <input (click)="$event.stopPropagation()" [formControl]="phitomAutocompleteCtrl"
                                [matAutocomplete]="phitomAutocomplete" [placeholder]="
                                            this.phitomTreeService.currentPhitom()
                                                ? phitomTreeService.currentPhitom().nameExtended
                                                    ? phitomTreeService.currentPhitom().nameExtended
                                                    : phitomTreeService.currentPhitom().name
                                                : '---'
                                        " class="phitom-autocomplete-input" growOnFocus
                                style="padding: 4px; margin-right: 6px" type="text" />
                            <mat-autocomplete #phitomAutocomplete="matAutocomplete"
                                (optionSelected)="setSelectedPhitom($event.option.value)" [displayWith]="phitomMapper">
                                @for (option of searchedPhitoms | async; track option) {
                                <mat-option [value]="option">
                                    {{ option.nameExtended ? option.nameExtended : option.name }}
                                </mat-option>
                                }
                            </mat-autocomplete>
                            }
                            <!--          <span style="margin-right: 12px">{{-->
                            <!--            currentPhitom ? (currentPhitom.nameExtended ? currentPhitom.nameExtended : currentPhitom.name) : '-&#45;&#45;'-->
                            <!--            }}</span>-->
                            <button mat-icon-button (click)="showHierachy = !showHierachy">
                                <mat-icon matTooltip="Baum anzeigen">account_tree</mat-icon>
                            </button>
                            <!--        <button-->
                            <!--          #overlayTrigger="cdkOverlayOrigin"-->
                            <!--      -->
                            <!--          cdkOverlayOrigin-->
                            <!--          mat-icon-button-->
                            <!--        >-->
                            <!--          -->
                            <!--        </button>-->
                        </div>
                        <div>
                            @if (showPhitomTree()) {
                            <ng-template (overlayOutsideClick)="
                                                $event.stopPropagation(); showHierachy = !showHierachy
                                            " [cdkConnectedOverlayOpen]="showHierachy"
                                [cdkConnectedOverlayOrigin]="overlayTrigger" cdkConnectedOverlay>
                                <div #phitomTreeOverlay cdkDrag cdkDragRootElement=".phitom-tree-window"
                                    class="phitom-tree-window">
                                    <div class="one-row" style="padding-bottom: 12px">
                                        <h3 style="margin-block-end: 0; margin-block-start: 0">Organisationsbaum (F9
                                            bzw. ALT+P)</h3>
                                        <span class="spacer"></span>
                                        <div (mousedown)="phitomTreeDragging = true"
                                            (mouseup)="phitomTreeDragging = false"
                                            [matTooltipDisabled]="phitomTreeDragging" cdkDragHandle
                                            matTooltip="Fensterposition verschieben"
                                            style="margin-left: 24px; cursor: move">
                                            <svg fill="#777" viewBox="0 0 24 24" width="24px">
                                                <path
                                                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                                                </path>
                                                <path d="M0 0h24v24H0z" fill="none"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <p style="color: gray; font-size: 0.8em">
                                        Nach dem Ausw&auml;hlen eines Zweiges werden nur noch die Daten
                                        angezeigt, die diesem Zweig zugeordnet sind.
                                    </p>
                                    <phito-phitom-tree (dialogOpened)="phitomTreeAddDialogOpen = $event"
                                        (selectedPhitomEmitter)="selectedPhitom($event)"
                                        [height]="'55vh'"></phito-phitom-tree>
                                </div>
                            </ng-template>
                            }
                        </div>
                    </div>
                    }
                    <!--Notification Center-->
                    @if (hasTicketPermission) {
                    <div>
                        <button mat-icon-button (click)="goToTickets()" matTooltip="Tickets">
                            <mat-icon>bug_report</mat-icon>
                        </button>
                    </div>
                    }
                    @if (hasNotificationPermission) {
                    <div class="notification-center-cell">
                        <phito-notification-center-button></phito-notification-center-button>
                    </div>
                    }
                    <!--AI-->
                    <div>
                        <button mat-icon-button (click)="openAiChat()" [disabled]="!hasAiChatPermission"
                            matTooltip="Frag phito.">
                            <mat-icon>tips_and_updates</mat-icon>
                        </button>
                    </div>

                    @if (showTodoQuickEntry && hasTodoPermission) {
                    <phito-todo-quick-entry-overlay></phito-todo-quick-entry-overlay>
                    }
                    <phito-profile-button [options]="options"></phito-profile-button>
                </div>
            </div>
            }

            <!-- Content Area -->
            <div class="one-row">
                @if (showSidenav()) {
                <div class="main-menu-column"
                    [ngStyle]="{width: mainMenuConfig()?.isShowMenuName() ? '105px' : '72px'}">
                    @if (hasFavoriteFilterPermission) {
                    <phito-favorite-menu-button [isMenuNameVisible]="mainMenuConfig()?.isShowMenuName()"
                        [ngClass]="{ 'active-menu-item': isActiveRouteFavorite() }"></phito-favorite-menu-button>
                    }
                    <!--          Main Menu-->
                    @for (mmi of mainMenuConfig()?.getMainMenuItems(); track mmi) {
                    <div style="text-align: center; margin-top: 6px">
                        <phito-main-menu-item [mmi]="mmi" (navigated)="navigated()"
                            [isMenuNameVisible]="mainMenuConfig()?.isShowMenuName()"></phito-main-menu-item>
                    </div>
                    }
                    <span class="column-spacer"></span>
                </div>
                }

                <div class="content-area">
                    <router-outlet></router-outlet>
                    <!-- Content Area -->
                </div>
            </div>
        </div>
    </mat-sidenav-content>
    <!--
    <mat-sidenav #rightSidebar position="end">
        <phito-simple-notification-list></phito-simple-notification-list>
    </mat-sidenav>
    -->
</mat-sidenav-container>